export const categories = [
  {
    slug: 'wanghong-fancha',
    name: '网红反差',
    icon: 'ri-contrast-2-line',
    description: '揭秘网红台前幕后的真实面目，曝光不为人知的反差瞬间'
  },
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    icon: 'ri-star-line',
    description: '娱乐圈最新八卦资讯，明星动态一手掌握'
  },
  {
    slug: 'dujia-jiemi',
    name: '独家揭秘',
    icon: 'ri-key-2-line',
    description: '深度调查报道，独家内幕真相大揭秘'
  },
  {
    slug: 'jingbao-neimu',
    name: '劲爆内幕',
    icon: 'ri-fire-line',
    description: '最劲爆的行业内幕，最震撼的黑料曝光'
  },
  {
    slug: 'chigua-shequ',
    name: '吃瓜社区',
    icon: 'ri-chat-smile-2-line',
    description: '吃瓜群众聚集地，热门话题讨论与爆料'
  },
  {
    slug: 'meiri-shishi',
    name: '每日实时',
    icon: 'ri-timer-flash-line',
    description: '每日实时更新，24小时不间断劲爆内容'
  }
];

export const articles = [
  {
    id: 1,
    slug: 'dingji-wanghong-beihou-zhenxiang',
    title: '顶级网红背后真相：滤镜下的真实生活与直播间外的崩溃瞬间',
    excerpt: '当滤镜消失、灯光关闭，那些拥有千万粉丝的顶级网红，究竟过着怎样的真实生活？本报独家深入调查，揭开设在公众面前的那层华丽面纱。',
    content: `<p>在当今社交媒体时代，网红已经成为一个庞大而复杂的群体。他们光鲜亮丽的外表和精心策划的内容背后，隐藏着许多不为人知的故事。</p>
    <p>据知情人士透露，某位拥有超过2000万粉丝的知名美妆博主，每次直播前需要花费超过3小时进行化妆和场景布置，而直播结束后的疲惫状态与镜头前判若两人。</p>
    <p>「压力太大了，」一位不愿透露姓名的MCN机构前员工表示，「很多网红表面上光鲜亮丽，实际上每天都要面对数据焦虑、粉丝期待和商业压力。」</p>
    <p>更有甚者，某知名带货主播被爆料在直播间笑容满面的同时，私下却因长期高强度工作导致严重的身心健康问题。这些反差让不少粉丝大跌眼镜。</p>
    <p>本报道将持续关注网红行业的生态现状，为读者还原一个真实的网红世界。</p>`,
    category: 'wanghong-fancha',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20live%20streaming%20studio%20with%20ring%20lights%20turned%20off%2C%20minimal%20set%20with%20scattered%20makeup%20products%20on%20a%20desk%2C%20moody%20atmospheric%20lighting%2C%20editorial%20documentary%20style%20photography%2C%20cinematic%20composition%20with%20shadows%20and%20negative%20space&width=1200&height=800&seq=article-dingji-wanghong&orientation=landscape',
    author: '吃瓜特派员',
    date: '2026-06-30',
    views: 128500,
    comments: 3287,
    tags: ['网红', '直播', '反差', '真实生活', 'MCN'],
    hot: true,
    hotIndex: '10w+'
  },
  {
    id: 2,
    slug: 'yixian-nvxing-hunbian-fengbo',
    title: '一线女星婚变风波升级：知情人曝更多惊人细节',
    excerpt: '继上周婚变传闻后，多位圈内人士陆续爆料，这起婚变事件远比外界想象的更加复杂。',
    content: `<p>近日，娱乐圈某一线女星的婚变风波持续发酵。虽然当事人至今保持沉默，但越来越多的圈内人士开始透露相关细节。</p>
    <p>据一位与该女星合作多年的圈内人透露：「事情远比大家看到的复杂，涉及到财产分割、子女抚养等多个方面。」</p>
    <p>更加令人震惊的是，有消息称婚变背后可能还涉及第三方的介入。虽然目前尚未得到当事人确认，但多个独立消息源都指向了同一方向。</p>
    <p>本报将持续关注此事的进展。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20silhouette%20of%20a%20woman%20standing%20alone%20on%20a%20balcony%20at%20sunset%2C%20luxury%20high-rise%20apartment%20cityscape%20in%20background%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20editorial%20photography%20mood%2C%20elegant%20and%20mysterious%20atmosphere&width=1200&height=800&seq=article-yixian-nvxing&orientation=landscape',
    author: '八卦探员',
    date: '2026-06-29',
    views: 289300,
    comments: 15240,
    tags: ['明星', '婚变', '娱乐圈', '爆料'],
    hot: true,
    hotIndex: '28w+'
  },
  {
    id: 3,
    slug: 'duan-shipin-pingtai-shuju-zaojia',
    title: '独家调查：某头部短视频平台数据造假产业链大起底',
    excerpt: '经过三个月的暗访调查，本报记者揭开了短视频行业数据造假的黑产链条。',
    content: `<p>在短视频行业蓬勃发展的背后，一个庞大的数据造假产业链正在悄然运作。本报记者历时三个月，深入调查了这一灰色产业链的运作模式。</p>
    <p>从刷量工作室到水军团队，从虚假账号到自动点赞系统，整个产业链分工明确、运作成熟。据估算，仅在某头部平台上，每天就有超过数百万条虚假互动。</p>
    <p>一位曾在水军公司工作的前员工向记者透露：「我们每天要操作数百个账号，按照客户要求进行点赞、评论和转发。有些网红的数据，超过60%都是假的。」</p>
    <p>这种数据造假行为不仅欺骗了广告主，更严重损害了整个行业的生态健康。</p>`,
    category: 'dujia-jiemi',
    image: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20rows%20of%20screens%20displaying%20social%20media%20dashboards%20and%20fake%20account%20interfaces%2C%20dim%20blue%20ambient%20lighting%2C%20cyberpunk%20aesthetic%2C%20investigative%20journalism%20mood%2C%20mysterious%20and%20suspenseful%20atmosphere&width=1200&height=800&seq=article-shuju-zaojia&orientation=landscape',
    author: '深度调查组',
    date: '2026-06-28',
    views: 456200,
    comments: 21350,
    tags: ['数据造假', '短视频', '暗访', '产业链', '独家'],
    hot: true,
    hotIndex: '45w+'
  },
  {
    id: 4,
    slug: 'dingliu-liuliang-xiaosheng-shuihou',
    title: '顶流小生税后收入曝光：年入过亿却拖欠员工工资？',
    excerpt: '某顶流男星被爆拖欠工作室员工薪资长达半年，而其个人年收入却轻松突破九位数。',
    content: `<p>近日，一则关于某顶流男星的爆料在圈内引起轩然大波。据其工作室前员工透露，这位年收入轻松过亿的顶流小生，竟然拖欠多名员工工资长达半年之久。</p>
    <p>「我们这些幕后工作人员每天都在拼命工作，保证他的行程和商务顺利进行，但我们的工资却一拖再拖，」一位前员工在接受采访时情绪激动的表示。</p>
    <p>据知情人士统计，该男星仅2025年的代言和影视收入就超过1.5亿元，而其工作室员工的平均月薪在1-2万元之间。</p>
    <p>这一反差引发了网友的强烈不满，相关话题迅速登上热搜。</p>`,
    category: 'jingbao-neimu',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20car%20parked%20in%20front%20of%20a%20modern%20glass%20skyscraper%20at%20night%2C%20rain-slicked%20streets%20reflecting%20city%20lights%2C%20wealthy%20contrast%20aesthetic%2C%20cinematic%20noir%20style%2C%20moody%20and%20dramatic%20atmosphere&width=1200&height=800&seq=article-dingliu-xiaosheng&orientation=landscape',
    author: '财经娱乐观察',
    date: '2026-06-27',
    views: 567800,
    comments: 28920,
    tags: ['顶流', '收入', '拖欠工资', '内幕'],
    hot: true,
    hotIndex: '56w+'
  },
  {
    id: 5,
    slug: 'reji-zongyi-beihou-juben',
    title: '热播综艺剧本曝光：那些你以为真实的节目都是演的',
    excerpt: '一份内部综艺剧本的意外流出，让观众看到了综艺节目背后精心设计的脚本内容。',
    content: `<p>综艺节目到底有多真实？一份意外流出的综艺节目剧本给出了令人震惊的答案。</p>
    <p>这份长达47页的剧本详细标注了每一位嘉宾的人设、每一段冲突的发展线、以及每一个感动时刻的情绪节奏。甚至连嘉宾流泪的时机都被精确到分钟。</p>
    <p>「这已经不是综艺了，这完全就是一部没有明说本故事纯属虚构的电视剧，」一位资深媒体人如此评价。</p>
    <p>虽然综艺节目有剧本早已是公开的秘密，但如此详细的剧本内容还是让很多观众感到被欺骗。</p>`,
    category: 'dujia-jiemi',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20reality%20show%20feeds%2C%20production%20crew%20silhouettes%2C%20warm%20studio%20lighting%20contrasting%20with%20dark%20control%20room%2C%20documentary%20style%2C%20behind%20the%20scenes%20atmosphere&width=1200&height=800&seq=article-zongyi-juben&orientation=landscape',
    author: '综艺观察员',
    date: '2026-06-26',
    views: 342100,
    comments: 18760,
    tags: ['综艺', '剧本', '曝光', '真实'],
    hot: false,
    hotIndex: '34w+'
  },
  {
    id: 6,
    slug: 'wanghong-daibei-jiamao',
    title: '知名吃播网红被爆代播假吃：镜头前的大胃王真相',
    excerpt: '粉丝打赏无数的吃播一姐，被爆料使用替身和剪辑手法造假。',
    content: `<p>吃播行业再爆造假丑闻。一位拥有500万粉丝的知名吃播博主被前员工爆料，其大胃王形象完全是靠替身和后期剪辑打造出来的。</p>
    <p>据爆料者称，该博主在拍摄时会使用特殊的拍摄角度和容器来制造海量的视觉效果，而实际吃下的食物量远少于呈现给观众的量。更令人震惊的是，在某些极端情况下，还会使用专业替身来完成大量进食的镜头。</p>
    <p>该爆料在社交平台引发广泛讨论，不少忠实粉丝表示幻灭。</p>`,
    category: 'wanghong-fancha',
    image: 'https://readdy.ai/api/search-image?query=Food%20photography%20studio%20setup%20with%20professional%20lighting%20equipment%20and%20camera%20pointing%20at%20a%20table%20full%20of%20dishes%2C%20behind%20the%20scenes%20of%20food%20content%20creation%2C%20warm%20studio%20lights%2C%20editorial%20documentary%20style&width=1200&height=800&seq=article-chibo-zaojia&orientation=landscape',
    author: '吃瓜特派员',
    date: '2026-06-25',
    views: 215600,
    comments: 12450,
    tags: ['吃播', '造假', '替身', '网红'],
    hot: false,
    hotIndex: '21w+'
  },
  {
    id: 7,
    slug: 'yulequan-qian-guize',
    title: '娱乐圈潜规则再升级：知名导演被多人实名举报',
    excerpt: '三名女演员同时发声，指控某知名导演利用职务之便进行不当行为。',
    content: `<p>娱乐圈的潜规则话题再度引发关注。近日，三位女演员通过社交媒体同时发声，实名举报某知名导演在选角过程中的不当行为。</p>
    <p>三位女演员提供的证据包括聊天记录、录音以及第三方证人证词。据她们描述，该导演在近三年的时间内，利用选角和试镜的机会，对多名年轻女演员进行不当行为。</p>
    <p>目前，该导演尚未对此事做出公开回应。相关行业协会表示将对此事展开调查。</p>`,
    category: 'jingbao-neimu',
    image: 'https://readdy.ai/api/search-image?query=Empty%20theater%20stage%20with%20a%20single%20spotlight%20casting%20long%20shadows%2C%20red%20velvet%20curtains%20partially%20drawn%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20composition%2C%20mysterious%20and%20suspenseful%20atmosphere&width=1200&height=800&seq=article-qian-guize&orientation=landscape',
    author: '娱乐调查科',
    date: '2026-06-24',
    views: 678900,
    comments: 35120,
    tags: ['潜规则', '实名举报', '导演', '娱乐圈'],
    hot: true,
    hotIndex: '67w+'
  },
  {
    id: 8,
    slug: 'zhiming-jingjiren-jieyue-neimu',
    title: '知名经纪人解约内幕：艺人被雪藏三年的残酷真相',
    excerpt: '一位刚刚解约成功的艺人经纪人，向本报独家透露了艺人被经纪公司雪藏的真实经历。',
    content: `<p>在光鲜亮丽的娱乐圈背后，雪藏是每个艺人最害怕的词汇之一。一位刚刚帮助旗下艺人成功解约的经纪人，向本报独家披露了艺人被雪藏的全过程。</p>
    <p>「所谓的雪藏，其实就是经济上的封锁和精神上的打压，」该经纪人表示，「公司会切断艺人所有的商业机会，同时利用合同条款限制艺人的任何公开活动，直到艺人屈服或合同到期。」</p>
    <p>据悉，那位艺人在被雪藏的三年间，不仅没有任何收入，还因为合同限制无法从事其他工作，生活完全陷入困境。</p>`,
    category: 'dujia-jiemi',
    image: 'https://readdy.ai/api/search-image?query=A%20lonely%20figure%20standing%20behind%20frosted%20glass%20window%20in%20a%20modern%20office%20building%2C%20soft%20diffused%20light%2C%20feeling%20of%20isolation%20and%20confinement%2C%20minimalist%20composition%2C%20moody%20atmospheric%20photography&width=1200&height=800&seq=article-xuecang&orientation=landscape',
    author: '深度调查组',
    date: '2026-06-23',
    views: 193400,
    comments: 9870,
    tags: ['经纪人', '雪藏', '解约', '内幕'],
    hot: false,
    hotIndex: '19w+'
  },
  {
    id: 9,
    slug: 'quanmin-chigua-redian-pandian',
    title: '六月吃瓜月报：本月最劲爆的十大娱乐事件盘点',
    excerpt: '回顾六月份娱乐圈最热门的事件，哪些瓜让你吃得最过瘾？',
    content: `<p>六月份娱乐圈可谓热闹非凡，各种爆料和事件层出不穷。以下是本月最受关注的十大事件盘点。</p>
    <p>从顶流婚变到综艺黑幕，从网红造假到明星维权，这个六月注定是吃瓜群众的天堂。</p>
    <p>无论是某顶流小生的欠薪事件，还是一线女星的婚变风波，每一条新闻都牵动着千万网友的心。而这些事件的背后，往往隐藏着更加复杂的利益关系和人性博弈。</p>
    <p>爆瓜网将持续为你带来最全面、最客观的娱乐资讯报道。</p>`,
    category: 'chigua-shequ',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20magazine%20cover%20collage%20style%20with%20various%20entertainment%20news%20headlines%20and%20images%20arranged%20artistically%2C%20vibrant%20pop%20art%20aesthetic%2C%20bold%20typography%2C%20editorial%20layout%20design%2C%20eye-catching%20and%20dynamic%20composition&width=1200&height=800&seq=article-chigua-yuebao&orientation=landscape',
    author: '吃瓜编辑部',
    date: '2026-06-30',
    views: 89200,
    comments: 5620,
    tags: ['月报', '盘点', '热门事件', '吃瓜'],
    hot: false,
    hotIndex: '8.9w+'
  },
  {
    id: 10,
    slug: 'wanghong-jingji-chanpai-fenxi',
    title: '网红经济大洗牌：2026年上半年MCN机构倒闭潮调查',
    excerpt: '曾经风光无限的MCN机构，正经历前所未有的寒冬。本报调查发现，多个头部机构面临倒闭风险。',
    content: `<p>2026年上半年，网红经济行业正在经历一场前所未有的大洗牌。据本报调查，至少有17家曾经颇具规模的MCN机构在今年上半年宣布倒闭或大幅裁员。</p>
    <p>行业分析师指出，流量红利消退、监管趋严、以及头部网红纷纷独立运营是导致这波倒闭潮的主要原因。</p>
    <p>「MCN的黄金时代已经过去了，」一位资深行业观察人士表示，「未来只有那些真正具备内容能力和商业闭环的机构才能活下来。」</p>`,
    category: 'meiri-shishi',
    image: 'https://readdy.ai/api/search-image?query=Empty%20modern%20open%20plan%20office%20with%20abandoned%20desks%20and%20chairs%2C%20moving%20boxes%20scattered%20around%2C%20dim%20natural%20light%20coming%20through%20large%20windows%2C%20corporate%20downsizing%20atmosphere%2C%20documentary%20photography%20style&width=1200&height=800&seq=article-mcn-daobi&orientation=landscape',
    author: '财经娱乐观察',
    date: '2026-06-29',
    views: 156700,
    comments: 8230,
    tags: ['网红经济', 'MCN', '倒闭', '行业分析'],
    hot: false,
    hotIndex: '15w+'
  },
  {
    id: 11,
    slug: 'kuaishou-douyin-zhibo-daibei',
    title: '快手抖音直播间背后的代播团队：月入十万的灰色职业',
    excerpt: '当你在深夜刷到喜欢的主播时，屏幕那头可能根本不是本人——一个神秘职业浮出水面。',
    content: `<p>代播——这个你可能从未听说过的职业，正在直播行业中悄然兴起。这些专业代播人员会在主播休息或处理其他事务时代替其出镜直播，而观众完全不会察觉。</p>
    <p>据了解，一位经验丰富的代播可以同时为3-5位主播提供服务，月收入轻松突破10万元。</p>
    <p>「很多大主播都有自己的代播团队，」一位业内人士透露，「观众以为自己看到的是主播本人，其实有相当一部分内容是由代播完成的。」</p>`,
    category: 'wanghong-fancha',
    image: 'https://readdy.ai/api/search-image?query=Person%20sitting%20at%20a%20desk%20with%20multiple%20phones%20and%20screens%20in%20a%20dimly%20lit%20room%2C%20streaming%20setup%20with%20ring%20light%2C%20mysterious%20atmosphere%2C%20only%20silhouette%20visible%2C%20noir%20photography%20style&width=1200&height=800&seq=article-zhibo-daibei&orientation=landscape',
    author: '吃瓜特派员',
    date: '2026-06-28',
    views: 234500,
    comments: 14320,
    tags: ['直播', '代播', '灰色产业', '快手', '抖音'],
    hot: true,
    hotIndex: '23w+'
  },
  {
    id: 12,
    slug: 'mingxing-ershi-siren-feiji',
    title: '明星私人飞机奢华大比拼：谁才是真正的空中豪宅？',
    excerpt: '从波音到湾流，明星们的私人飞机究竟有多奢华？一场没有硝烟的炫富战争。',
    content: `<p>私人飞机一直是明星炫富的终极象征。近年来，越来越多的中国明星加入了私人飞机俱乐部，而他们的座驾一台比一台奢华。</p>
    <p>从价值5000万美元的湾流G650到改装费用超过2000万美元的波音商务机，明星们的空中豪宅令人瞠目结舌。据不完全统计，目前至少有15位中国一线明星拥有自己的私人飞机。</p>
    <p>然而，这些奢华座驾背后的维护成本和环境争议，也让不少明星陷入了舆论漩涡。</p>`,
    category: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20private%20jet%20interior%20with%20cream%20leather%20seats%20and%20gold%20accents%2C%20champagne%20glasses%20on%20a%20marble%20table%2C%20warm%20ambient%20lighting%2C%20ultra-luxury%20lifestyle%20photography%2C%20rich%20and%20opulent%20atmosphere&width=1200&height=800&seq=article-siren-feiji&orientation=landscape',
    author: '八卦探员',
    date: '2026-06-27',
    views: 178900,
    comments: 9340,
    tags: ['明星', '私人飞机', '奢华', '炫富'],
    hot: false,
    hotIndex: '17w+'
  }
];

export const testimonials = [
  {
    id: 1,
    name: '吃瓜群众老王',
    avatar: '',
    comment: '这个网站太绝了！每天都有新瓜吃，内容真实度也很高，已经成为我每天的必刷网站了。',
    rating: 5
  },
  {
    id: 2,
    name: '八卦小能手',
    avatar: '',
    comment: '比那些娱乐号强太多了，爆料都是有理有据的，不是随便编造。强烈推荐！',
    rating: 5
  },
  {
    id: 3,
    name: '夜猫子吃瓜',
    avatar: '',
    comment: '深夜刷到好多劲爆内容，根本停不下来。更新速度是真的快，好评！',
    rating: 4
  },
  {
    id: 4,
    name: '理性吃瓜人',
    avatar: '',
    comment: '内容很丰富，分类也很清晰。希望继续保持客观公正的报道态度，不要为了流量夸大事实。',
    rating: 4
  },
  {
    id: 5,
    name: '娱乐圈观察家',
    avatar: '',
    comment: '深度报道做得特别好，能看出来是认真在做内容的。比那些只会转载的媒体强多了。',
    rating: 5
  }
];